import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { DividerModule } from 'primeng/divider';
import { FormsModule } from '@angular/forms';
import { AppearanceSettingsComponent } from "./components/appearance-settings.component";
import { ProfileSettingsComponent } from "./components/profile-settings.component";
import { NotificationSettingsComponent } from "./components/notification-settings.component";
import { GeneralSettingsComponent } from './components/general-settings.component';
import { AppAuthService } from '@/services/app/auth.service';
import { BinderDialogService } from '@/services/app/binder-dialog.service';
import { TitleCasePipe } from '@/pipes/title-case.pipe';


type ProfileType = {
  givenName?: string,
  surname?: string,
  userPrincipalName?: string,
  id?: string
};

@Component({
    selector: 'app-profile',
    imports: [
        CommonModule, 
        DividerModule, 
        FormsModule, 

        AppearanceSettingsComponent, 
        ProfileSettingsComponent, 
        NotificationSettingsComponent, 
        GeneralSettingsComponent, 
        TitleCasePipe],
    template: `
        <div class="grid grid-cols-12 gap-2">
            <div class="col-span-12 lg:col-span-2">
                <ul class="list-none m-0 p-0 hidden lg:flex flex-col justify-start">
                <li
  *ngFor="let tab of tabs"
  [ngClass]="[
    '-ml-[2px]',
    selectedTab === tab.label
      ? 'border-l-2 border-primary'
      : 'border-l-2 border-surface-200 dark:border-surface-700 hover:border-primary hover:text-primary transition-colors'
  ]"
>
  <a
    class="flex items-center cursor-pointer py-3 px-4 font-medium"
    [ngClass]="selectedTab === tab.label
      ? 'text-primary'
      : 'text-surface-700 dark:text-surface-200'"
    (click)="selectedTab = tab.label"
  >
    <i
      class="mr-2 !text-base !leading-normal"
      [ngClass]="tab.icon"
    ></i>
    <span>{{ tab.label | titleCase }}</span>
  </a>
</li>
                </ul>

            </div>

            <div class="col-span-12 lg:col-span-10 bg-surface-0 dark:bg-surface-900 p-7 shadow rounded-2xl flex-auto">
                <div class="flex flex-col gap-7">
                <ng-container [ngSwitch]="selectedTab">
            <div class="border-round flex-auto">
                <div class="text-900 font-semibold text-lg mt-2">{{selectedTab | titleCase}} Settings</div>
                <p-divider></p-divider>
                <app-appearance-settings *ngSwitchCase="'appearance'"></app-appearance-settings>
                <app-profile-settings *ngSwitchCase="'profile'"></app-profile-settings>
                <app-notification-settings *ngSwitchCase="'notifications'"></app-notification-settings>
               <!-- <app-user-office-settings *ngSwitchCase="'office'"></app-user-office-settings> -->
                <app-general-settings *ngSwitchCase="'general'"></app-general-settings>
            </div>
        </ng-container>  
                </div>
            </div>
        </div>


<!-- 
        <div class="p-fluid flex flex-column lg:flex-row" style="min-height: 350px;">
        <ul class="list-none m-0 p-0 flex flex-row lg:flex-column justify-content-evenly md:justify-content-between lg:justify-content-start mb-5 lg:mb-0">
            <li *ngFor="let tab of tabs">
                <a pRipple (click)="changeTab(tab.label)" class="flex align-items-center cursor-pointer p-3 border-round text-800 hover:surface-hover transition-duration-150 transition-colors">
                    <i [class]="tab.icon + ' ml-2'" [ngClass]="{'text-primary': selectedTab === tab.label}"></i>
                    <span class="font-medium hidden md:block mr-6 ml-1" [ngClass]="{'text-primary font-bold': selectedTab === tab.label}">{{tab.label | titleCase }}</span>
                </a>
            </li>
        </ul>
        <ng-container [ngSwitch]="selectedTab">
            <div class="border-round flex-auto">
                <div class="text-900 font-semibold text-lg mt-2">{{selectedTab | titleCase}} Settings</div>
                <p-divider></p-divider>
                <app-appearance-settings *ngSwitchCase="'appearance'"></app-appearance-settings>
                <app-profile-settings *ngSwitchCase="'profile'"></app-profile-settings>
                <app-notification-settings *ngSwitchCase="'notifications'"></app-notification-settings>
               <app-user-office-settings *ngSwitchCase="'office'"></app-user-office-settings>
                <app-general-settings *ngSwitchCase="'general'"></app-general-settings>
            </div>
        </ng-container>          
    </div> -->
    `,
    standalone: true,
})
export class ProfileComponent {
  profileSubscription!: Subscription;
  selectedTab: string = 'profile';

  tabs: {label: string, icon: string}[] = [
    {label: 'profile', icon: 'pi pi-user md:mr-2'},
    {label: 'general', icon: 'pi pi-cog md:mr-2'},
    // {label: 'office', icon: 'pi pi-building md:mr-2'},
    {label: 'appearance', icon: 'pi pi-palette md:mr-2'},
    // {label: 'notifications', icon: 'pi pi-bell md:mr-2'},
  ];

  constructor(private profileService: AppAuthService, private binderDialogService: BinderDialogService) {}

  changeTab(tab: string) {
    this.selectedTab = tab;
  }

  get profileData() {
    return this.profileService.userData();
  }
}
